/**
 * Returns country flags emoji for the given country code/currency code.
 * @param countryNameOrCode
 * @returns
 */
export function countryFlagEmoji(countryNameOrCode: string): string {
  const countryNameOrCodeLC = countryNameOrCode?.toLowerCase();

  switch (countryNameOrCodeLC) {
    case 'united states':
    case 'usa':
    case 'us':
    case 'usd':
      return '🇺🇸';
    case 'china':
    case 'cn':
    case 'cny':
      return '🇨🇳';
    case 'russian federation':
    case 'russia':
    case 'ru':
    case 'rub':
      return '🇷🇺';
    case 'spain':
    case 'es':
      return '🇪🇸';
    case 'france':
    case 'fr':
    case 'ff':
      return '🇫🇷';
    case 'australia':
    case 'au':
    case 'aud':
      return '🇦🇺';
    case 'germany':
    case 'de':
      return '🇩🇪';
    case 'brazil':
    case 'br':
    case 'brl':
      return '🇧🇷';
    case 'italy':
    case 'it':
      return '🇮🇹';
    case 'poland':
    case 'pl':
    case 'pln':
      return '🇵🇱';
    case 'ukraine':
    case 'ua':
    case 'uah':
      return '🇺🇦';
    case 'united kingdom':
    case 'uk':
    case 'gb':
    case 'gbp':
      return '🇬🇧';
    case 'israel':
    case 'il':
    case 'ils':
      return '🇮🇱';
    case 'turkey':
    case 'türkiye':
    case 'turkiye':
    case 'tr':
    case 'try':
      return '🇹🇷';
    case 'indonesia':
    case 'id':
    case 'idr':
      return '🇮🇩';
    case 'czech republic':
    case 'czechia':
    case 'cz':
    case 'czk':
      return '🇨🇿';
    case 'korea':
    case 'south korea':
    case 'kr':
    case 'krw':
      return '🇰🇷';
    case 'united arab emirates':
    case 'ae':
    case 'aed':
      return '🇦🇪';
    case 'saudi arabia':
    case 'sa':
    case 'sar':
      return '🇸🇦';
    case 'chile':
    case 'cl':
    case 'clp':
      return '🇨🇱';
    case 'hungary':
    case 'hu':
    case 'huf':
      return '🇭🇺';
    case 'japan':
    case 'jp':
    case 'jpy':
      return '🇯🇵';
    case 'lithuania':
    case 'lt':
    case 'ltl':
      return '🇱🇹';
    case 'latvia':
    case 'lv':
    case 'lvr':
      return '🇱🇻';
    case 'nigeria':
    case 'ng':
    case 'ngn':
      return '🇳🇬';
    case 'vietnam':
    case 'vn':
    case 'vnd':
      return '🇻🇳';
    case 'south africa':
    case 'za':
    case 'zar':
      return '🇿🇦';
    case 'eu':
    case 'eur':
      return '🇪🇺';

    // new countries
    case 'afghanistan':
    case 'af':
    case 'afn':
      return '🇦🇫';
    case 'albania':
    case 'al':
    case 'all':
      return '🇦🇱';
    case 'algeria':
    case 'dz':
    case 'dzd':
      return '🇩🇿';
    case 'samoa':
    case 'ws':
    case 'wsm':
      return '🇼🇸';
    case 'american samoa':
    case 'as':
    case 'asd':
      return '🇦🇸';
    case 'andorra':
    case 'ad':
    case 'adp':
      return '🇦🇩';
    case 'angola':
    case 'ao':
    case 'aoa':
      return '🇦🇴';
    case 'anguilla':
    case 'ai':
    case 'antarctica':
    case 'aq':
    case 'aqd':
      return '🇦🇶';
    case 'antigua and barbuda':
    case 'ag':
    case 'xcd':
      return '🇦🇬';
    case 'argentina':
    case 'ar':
    case 'ars':
      return '🇦🇷';
    case 'armenia':
    case 'am':
    case 'amd':
      return '🇦🇲';
    case 'aruba':
    case 'aw':
    case 'awg':
      return '🇦🇼';
    case 'austria':
    case 'at':
    case 'ats':
      return '🇦🇹';
    case 'azerbaijan':
    case 'az':
    case 'azn':
      return '🇦🇿';
    case 'bahamas':
    case 'bs':
    case 'bsd':
      return '🇧🇸';
    case 'bahrain':
    case 'bh':
    case 'bhd':
      return '🇧🇭';
    case 'bangladesh':
    case 'bd':
    case 'bdt':
      return '🇧🇩';
    case 'barbados':
    case 'bb':
    case 'bbd':
      return '🇧🇧';
    case 'belarus':
    case 'by':
    case 'byn':
      return '🇧🇾';
    case 'belgium':
    case 'be':
    case 'bef':
      return '🇧🇪';
    case 'belize':
    case 'bz':
    case 'bzd':
      return '🇧🇿';
    case 'benin':
    case 'bj':
    case 'bjf':
      return '🇧🇯';
    case 'bermuda':
    case 'bm':
    case 'bmd':
      return '🇧🇲';
    case 'bhutan':
    case 'bt':
    case 'btn':
      return '🇧🇹';
    case 'bolivia':
    case 'bo':
    case 'bob':
      return '🇧🇴';
    case 'bosnia and herzegovina':
    case 'ba':
    case 'bam':
      return '🇧🇦';
    case 'botswana':
    case 'bw':
    case 'bwp':
      return '🇧🇼';
    case 'norway':
    case 'no':
    case 'nok':
    case 'bouvet island':
    case 'bv':
      return '🇧🇻';
    case 'british indian ocean territory':
    case 'io':
    case 'iot':
      return '🇮🇴';
    case 'brunei':
    case 'bn':
    case 'bnd':
      return '🇧🇳';
    case 'bulgaria':
    case 'bg':
    case 'bgn':
      return '🇧🇬';
    case 'burkina faso':
    case 'bf':
    case 'bff':
      return '🇧🇫';
    case 'burundi':
    case 'bi':
    case 'bif':
      return '🇧🇮';
    case 'cambodia':
    case 'kh':
    case 'khr':
      return '🇰🇭';
    case 'cameroon':
    case 'cm':
    case 'cdf':
      return '🇨🇲';
    case 'canada':
    case 'ca':
    case 'cad':
      return '🇨🇦';
    case 'cape verde':
    case 'cv':
    case 'cvd':
      return '🇨🇻';
    case 'cayman islands':
    case 'ky':
    case 'kyd':
      return '🇰🇾';
    case 'central african republic':
    case 'cf':
    case 'xaf':
      return '🇨🇫';
    case 'chad':
    case 'td':
    case 'tdf':
      return '🇹🇩';
    case 'christmas island':
    case 'cx':
    case 'cxd':
      return '🇨🇽';
    case 'cocos (keeling) islands':
    case 'cc':
    case 'cck':
      return '🇨🇨';
    case 'colombia':
    case 'co':
    case 'cou':
      return '🇨🇴';
    case 'comoros':
    case 'km':
    case 'kmd':
      return '🇰🇲';
    case 'congo':
    case 'cg':
      return '🇨🇬';
    case 'cook islands':
    case 'ck':
    case 'ckd':
      return '🇨🇰';
    case 'costa rica':
    case 'cr':
    case 'crc':
      return '🇨🇷';
    case "cote d'ivoire":
    case 'ci':
    case 'civ':
      return '🇨🇮';
    case 'croatia':
    case 'hr':
    case 'hrk':
      return '🇭🇷';
    case 'cuba':
    case 'cu':
    case 'cup':
      return '🇨🇺';
    case 'curacao':
    case 'cw':
    case 'cwf':
      return '🇨🇼';
    case 'cyprus':
    case 'cy':
    case 'cyp':
      return '🇨🇾';
    case 'india':
    case 'in':
    case 'inr':
      return '🇮🇳';
    case 'jamaica':
    case 'jm':
    case 'jmd':
      return '🇯🇲';
    case 'kazakhstan':
    case 'kz':
    case 'kzt':
      return '🇰🇿';
    case 'mexico':
    case 'mx':
    case 'mxn':
      return '🇲🇽';
    case 'morocco':
    case 'ma':
    case 'mad':
      return '🇲🇦';
    case 'netherlands':
    case 'nl':
    case 'nlg':
      return '🇳🇱';
    case 'new zealand':
    case 'nz':
    case 'nzd':
      return '🇳🇿';
    case 'pakistan':
    case 'pk':
    case 'pkr':
      return '🇵🇰';
    case 'peru':
    case 'pe':
    case 'pen':
      return '🇵🇪';
    case 'philippines':
    case 'ph':
    case 'php':
      return '🇵🇭';
    case 'romania':
    case 'ro':
    case 'ron':
      return '🇷🇴';
    case 'rwanda':
    case 'rw':
    case 'rwf':
      return '🇷🇼';
    case 'serbia':
    case 'rs':
    case 'rsd':
      return '🇷🇸';

    case 'sweden':
    case 'se':
    case 'sek':
      return '🇸🇪';

    case 'singapore':
    case 'sg':
    case 'sgd':
      return '🇸🇬';

    case 'switzerland':
    case 'ch':
    case 'chf':
      return '🇨🇭';

    case 'thailand':
    case 'th':
    case 'thb':
      return '🇹🇭';
    case 'venezuela':
    case 've':
    case 'vef':
      return '🇻🇪';

    case 'taiwan':
    case 'tw':
    case 'twd':
      return '🇹🇼';

    case 'denmark':
    case 'dk':
    case 'dkk':
      return '🇩🇰';

    case 'egypt':
    case 'eg':
    case 'egp':
      return '🇪🇬';

    case 'malaysia':
    case 'my':
      return '🇲🇾';

    case 'portugal':
    case 'pt':
      return '🇵🇹';

    case 'greece':
    case 'gr':
      return '🇬🇷';

    case 'jordan':
    case 'jo':
      return '🇯🇴';

    case 'finland':
    case 'fi':
      return '🇫🇮';

    case 'ireland':
    case 'ie':
      return '🇮🇪';

    case 'malta':
    case 'mt':
      return '🇲🇹';

    case 'luxembourg':
    case 'lu':
      return '🇱🇺';

    case 'estonia':
    case 'ee':
      return '🇪🇪';

    case 'slovakia':
    case 'sk':
      return '🇸🇰';

    case 'slovenia':
    case 'si':
      return '🇸🇮';

    case 'georgia':
    case 'ge':
      return '🇬🇪';

    case 'nicaragua':
    case 'ni':
      return '🇳🇮';

    case 'ecuador':
    case 'ec':
      return '🇪🇨';

    case 'paraguay':
    case 'py':
      return '🇵🇾';

    case 'dominican republic':
    case 'do':
      return '🇩🇴';

    case 'uruguay':
    case 'uy':
      return '🇺🇾';

    case 'guatemala':
    case 'gt':
      return '🇬🇹';

    case 'latin america':
    case 'latam':
      return '🌎';

    case 'el salvador':
    case 'sv':
      return '🇸🇻';

    case 'honduras':
    case 'hn':
      return '🇭🇳';

    case 'panama':
    case 'pa':
      return '🇵🇦';

    case 'papua new guinea':
    case 'pg':
      return '🇵🇬';

    case 'fiji':
    case 'fj':
      return '🇫🇯';

    case 'zimbabwe':
    case 'zw':
      return '🇿🇼';

    case 'iceland':
    case 'is':
      return '🇮🇸';
    case 'suriname':
    case 'sr':
      return '🇸🇷';
    case 'guyana':
    case 'gy':
      return '🇬🇾';
    case 'iran':
    case 'ir':
      return '🇮🇷';
    case 'puerto rico':
    case 'pr':
      return '🇵🇷';
    case 'kiribati':
    case 'ki':
      return '🇰🇮';
    case 'marshall islands':
    case 'mh':
      return '🇲🇭';
    case 'tonga':
    case 'to':
      return '🇹🇴';
    case 'vanuatu':
    case 'vu':
      return '🇻🇺';
    case 'solomon islands':
    case 'sb':
      return '🇸🇧';
    case 'montenegro':
    case 'me':
      return '🇲🇪';

    case 'hong kong':
    case 'hk':
      return '🇭🇰';

    default:
      // default red flag
      // Obviously we missed a country, need to fix this
      return '🚩';
  }
}
